module.exports = __webpack_public_path__ + "static/img/inform_2@2x.84689a59.png";